import $ from 'jquery';

export default class {
  constructor(formSelector, startEvent, submitEvent, isForceSubmit = false) {
    if (typeof formSelector === 'undefined' || typeof startEvent === 'undefined' || typeof submitEvent === 'undefined') {
      throw new Error('Some arguments are not passed to the constructor.');
    }
    this.selector = formSelector;
    this.formStarted = false;
    this.startEvent = startEvent;
    this.submitEvent = submitEvent;
    this.isForceSubmit = isForceSubmit;
  }

  init() {
    const that = this;
    const $form = $(this.selector);
    window.dataLayer = window.dataLayer || [];

    // input/textarea
    $form.on('input change', 'input:not([type=hidden]), textarea', function(e) {
      if (!e.originalEvent || e.isTrigger) return;

      that.fireStartEvent();
    });

    // simple select (not select2)
    $form.on('change', 'select', function(e) {
      if ($(this).data('select2')) return;
      if (!e.originalEvent || e.isTrigger) return;

      that.fireStartEvent();
    });

    // select2
    $form.on('select2:select select2:unselect', 'select', function() {
      that.fireStartEvent();
    });

    $(this.selector).on('submit', function (event) {
      event.preventDefault();

      if ($(this).valid()) {
        window.dataLayer.push({
          'event': that.submitEvent
        });

        setTimeout(() => {
          if (that.isForceSubmit) {
            event.currentTarget.submit();
          }
        }, 800);
      }
    });
  }

  fireStartEvent() {
    if (this.formStarted) return;

    this.formStarted = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: this.startEvent });
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/classes/form-events.class.js